"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { trackProductEvent } from "@/lib/analytics";

// Intern lenke til butikken med et lettvekts select_content-klikk-event,
// for bruk i server-komponenter som ikke selv kan ha onClick.
export function TrackedLink({
  href,
  className,
  children,
  contentName,
  method,
  hendelse,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  contentName: string;
  method: string;
  /** Eget GA4-hendelsesnavn i tillegg til select_content. Hendelsesnavn er
   *  rapporterbare i GA4 uten oppsett, mens parametere som `method` krever en
   *  registrert egendefinert dimensjon. Brukes der én bestemt plassering skal
   *  kunne måles alene (målt fra 2.10.2026, se dokumenter/maalinger/). */
  hendelse?: string;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => {
        trackProductEvent("select_content", { content_name: contentName, method });
        if (hendelse) {
          (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag?.("event", hendelse, { content_name: contentName, method });
        }
      }}
    >
      {children}
    </Link>
  );
}
